
import { Client, Project, Task, Transaction, UserProfile, Role, CompanyInfo, BriefingField } from './types';

export const USER_PROFILE_IMAGE = "https://lh3.googleusercontent.com/aida-public/AB6AXuDwMIDdQLvEiaAZSZHJ10VI5jM_Q_lODGGdtsmDGvhIb9QpqzwhpJXGCLu2wZN27Lpf0NivKE565z2bbsg-1bTjX_KpGdyCXOLezQRboiQF81dSPcP8jYOlqt4VyAdJchx2rhewiWE1S3VDbhXs4GGf4gRStGJGZupFLQd18O_nSfDpwOSsBKhI4InuHHcTg_3fsLQ80XlrcmGe7dlcDGdxxFfGZPo9TCkQTGE2TArymwMY-oFflBUYgPin_d-PbwRRr4dXLvMNm1TD";

export const DEFAULT_BRIEFING: BriefingField[] = [
  { id: 'b1', label: 'Qual o principal objetivo do projeto?', type: 'textarea', placeholder: 'Ex: Aumentar vendas, automatizar processos...' },
  { id: 'b2', label: 'Qual o público-alvo principal?', type: 'text', placeholder: 'Ex: Jovens de 18-25 anos, B2B...' },
  { id: 'b3', label: 'Tipo de solução desejada', type: 'select', options: ['Site Institucional', 'Landing Page', 'Aplicativo Mobile', 'Sistema Web / ERP Customizado', 'E-commerce'] },
  { id: 'b4', label: 'Já possui identidade visual (Logotipo, Cores)?', type: 'select', options: ['Sim, completa', 'Apenas logotipo', 'Não, precisarei criar'] },
  { id: 'b5', label: 'Funcionalidades indispensáveis', type: 'textarea', placeholder: 'Ex: Chat, Pagamentos, Área do Cliente...' },
  { id: 'b6', label: 'Prazo ideal para lançamento', type: 'text', placeholder: 'Ex: 3 meses, Dezembro/2026...' }
];

export const INITIAL_COMPANY: CompanyInfo = {
  name: "Magenta Desenvolve",
  cnpj: "00.000.000/0001-00",
  address: "Av. Paulista, 1000 - São Paulo, SP",
  phone: "(11) 99999-9999",
  email: "contato@magentadesenvolve.com",
  logoUrl: "",
  briefingTemplate: DEFAULT_BRIEFING
};

export const INITIAL_ROLES: Role[] = [
  { id: "r1", name: "Administrador", permissions: ["all"] },
  { id: "r2", name: "Gerente de Projetos", permissions: ["projects", "tasks"] },
  { id: "r3", name: "Financeiro", permissions: ["financials"] }
];

// Fix: Use UserProfile interface and its required fields
export const INITIAL_USERS: UserProfile[] = [
  {
    id: "u1",
    name: "Admin Principal",
    email: "magentadesenvolve@gmail.com",
    role: "admin",
    avatarUrl: USER_PROFILE_IMAGE,
    isFirstLogin: false
  }
];

export const CLIENTS: Client[] = [
  {
    id: "#CL-8921",
    name: "Acme Corp",
    tradingName: "Acme Soluções LTDA",
    type: "SaaS",
    contactName: "Sarah Jenkins",
    contactRole: "CTO",
    email: "sarah@acme.com",
    phone: "(11) 98888-7777",
    cnpj: "12.345.678/0001-99",
    address: "Rua das Flores, 123 - São Paulo, SP",
    logoUrl: "https://ui-avatars.com/api/?name=Acme&background=8a0049&color=fff&rounded=true",
    avatarUrl: "https://ui-avatars.com/api/?name=Sarah&background=fcebf5&color=8a0049&rounded=true",
    status: "Active",
    activeProjectsCount: 1,
    briefing: [
      { id: 'b1', label: 'Qual o principal objetivo do projeto?', type: 'textarea', value: 'Queremos automatizar nosso processo de vendas B2B que hoje é feito em planilhas.' },
      { id: 'b2', label: 'Qual o público-alvo principal?', type: 'text', value: 'Empresas de logística de médio porte.' },
      { id: 'b3', label: 'Tipo de solução desejada', type: 'select', value: 'Sistema Web / ERP Customizado' },
      { id: 'b4', label: 'Já possui identidade visual?', type: 'select', value: 'Sim, completa' }
    ]
  }
];

export const PROJECTS: Project[] = [
  { id: "P1", name: "Redesign de Website", client: "Acme Corp", deadline: "12 Nov", status: "Active", completion: 60 },
  { id: "P2", name: "Dev App Mobile", client: "Starlight Inc", deadline: "05 Dez", status: "Review", completion: 25 },
  { id: "P3", name: "Integração CRM", client: "Global Tech", deadline: "30 Out", status: "Planning", completion: 15 }
];

export const TASKS: Task[] = [
  {
    id: "T1",
    name: "Design do Esquema do Banco",
    description: "Definir tabelas e relacionamentos.",
    status: "To Do",
    tag: "Design",
    assigneeAvatar: "https://ui-avatars.com/api/?name=Marcos&background=8a0049&color=fff&rounded=true",
    checklist: [
      { id: "c1", text: "Modelagem ER", done: false },
      { id: "c2", text: "Dicionário de Dados", done: false },
      { id: "c3", text: "Scripts SQL Inicial", done: false },
      { id: "c4", text: "Aprovação do Tech Lead", done: false }
    ]
  },
  {
    id: "T2",
    name: "Implementação de Layout Home",
    description: "Layout responsivo com Tailwind.",
    status: "Doing",
    tag: "Frontend",
    assigneeAvatar: "https://ui-avatars.com/api/?name=Sophia&background=8a0049&color=fff&rounded=true",
    checklist: [
      { id: "c5", text: "Header Sticky", done: true },
      { id: "c6", text: "Seção Hero", done: true },
      { id: "c7", text: "Grid de Serviços", done: true },
      { id: "c8", text: "Otimização de Imagens", done: false },
      { id: "c9", text: "Testes Mobile", done: false }
    ]
  }
];

export const TRANSACTIONS: Transaction[] = [
  { id: "INV-0024", client: "Acme Corp", plan: "Enterprise", date: "24 Out, 2023", amount: 2450.00, status: "Paid", initials: "AC" },
  { id: "INV-0025", client: "Globex Inc.", plan: "Padrão", date: "23 Out, 2023", amount: 850.00, status: "Paid", initials: "GL" },
  { id: "INV-0026", client: "Stark Tech", plan: "Enterprise", date: "22 Out, 2023", amount: 4200.00, status: "Paid", initials: "ST" }
];
